export default __webpack_public_path__ + "static/media/2.33bc3f9b.jpg";